import { BaseItem } from './common';
import * as Practice from './practice';
import { UserIdentification } from './user';

export enum Kind {
  EHR = 'EHR',
  HL7 = 'HL7',
  API = 'API',
}

export interface BaseEhrProviderInformation {
  practiceId: string; // foreign key to Practice.id for practice uuid
  providerUserId: string; // foreign key to User.id for provider user uuid
  kind: Kind; // kind of identifier, ie "EHRID" or "NPI"; can be undefined (will be '' in DB if undefined)
  value: string; // value from practice EHR itself.  value must be unique for a given practiceId, type
}

export interface EhrProviderInformation
  extends BaseEhrProviderInformation,
    BaseItem {}

export interface EhrProviderInformationPopulated
  extends EhrProviderInformation,
    UserIdentification,
    Omit<Practice.Practice, 'kind' | 'phoneNumber'> {
  practiceKind: Practice.Kind;
  practicePhoneNumber: string;
}
